// extracted by mini-css-extract-plugin
export default {"cardHeader":"HistoryListTable_cardHeader__Xretg","dateBadge":"HistoryListTable_dateBadge__5ukxo","title":"HistoryListTable_title__4bKRc"};